import $ from 'jquery'

/**
 * Adapter for JQuery's form submit method trigger.
 * @param {HTMLElement} form - The form element
 * @returns {void}
 */
export default (form) => {
  $(form).trigger('submit')
}
